<template>
  <div class="content-form vehicle-field">
    <div class="columns">
      <div class="field column selection">
        <b-select v-model="vehicleType" :placeholder="$t('driver_onboarding.profile.vehicle.vehicle_type')" 
          @input="onChangeVehicleType">
          <option v-for="option in vehicleOptions" :value="option.value" :key="option.value">
            {{option.name}}
          </option>
        </b-select>
        <b-select v-model="truckType" v-if="isTruck"
          class="option-truck"
          :placeholder="$t('driver_onboarding.profile.vehicle.vehicle_type')"
          @input="onChangeTruckType">
          <option v-for="option in truckOptions" :value="option.value" :key="option.value">
            {{option.name}}
          </option>
        </b-select>
      </div>
      <div class="field column">
        <InputField
          type="text"
          name="drivingLicense"
          :labelName="$t('driver_onboarding.profile.vehicle.driving_license')"
          @onChange="onChangeDrivingLicense"
          :initValue="drivingLicense"
        />
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="field">
        <div class="is-flex license-plates">
          <p>{{ $t('driver_onboarding.profile.vehicle.plate_number') }}</p>
          <input
            type="text"
            class="first"
            maxlength="4"
            tabindex="1"
            @input="onChangePlateNumber"
            v-model="plateNumberFirstRow"
          />
          <img src="/img/icons/separate.svg" />
          <input
            type="text"
            class="second"
            maxlength="5"
            tabindex="2"
            @input="onChangePlateNumber"
            v-model="plateNumberSecondRow"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputField from "@/components/InputField.vue";
import {mapGetters} from "vuex"

const VEHICLE = {
  TRUCK: "TRUCK",
  MOTORBIKE: "MOTORBIKE"
};
const TYPE_TRUCK = {
  TRICYCLE  : "TRICYCLE",
  TRUCK_300 : "TRUCK_300",
  TRUCK_500 : "TRUCK_500",
  TRUCK_750 : "TRUCK_750",
  TRUCK_1000: "TRUCK_1000",
  TRUCK_1600: "TRUCK_1600",
  TRUCK_5000: "TRUCK_5000",
  TRUCK_9000: "TRUCK_9000" 
}

export default {
  components: {
    InputField
  },
  data() {
    let vehicleOptions = []
    for (let key in VEHICLE) {
      vehicleOptions.push({
        name: this.$t(`driver_onboarding.profile.vehicle.${key.toLowerCase()}`),
        value: key
      })
    }
    let truckOptions = []
    for (let key in TYPE_TRUCK) {
      if (key === 'TRICYCLE') {
        truckOptions.push({
          name: this.$t('driver_onboarding.profile.vehicle.tricycle'),
          value: key
        })
      } else {
        const weight = key.split('_')[1]      
        truckOptions.push({
          name: this.$t('driver_onboarding.profile.vehicle.truck_type', { weight }),
          value: key
        })
      }      
    }

    return {
      vehicleOptions,
      truckOptions,

      vehicleType: null,
      truckType: null,
      drivingLicense: null,

      plateNumberFirstRow: null,
      plateNumberSecondRow: null
    };
  },
  computed: {
    ...mapGetters(['formData']),
    isTruck () {
      return this.vehicleType && this.vehicleType === VEHICLE.TRUCK
    },
    firstPlateNumber() {
      const data = this.supplierProfile && this.supplierProfile.plate_number;
      let result = ''
      if(data){
        result = data.split("-")[0].trim();
      }
      return result;
    },
    secondPlateNumber() {
      const data = this.supplierProfile && this.supplierProfile.plate_number;
      let result = ''
      if(data){
        result = data.split("-")[1].trim();
      }
      return result;
    }
  },
  methods: {
    setVehicleProfile () {
      const first = this.plateNumberFirstRow && this.plateNumberFirstRow.trim()
      const second = this.plateNumberSecondRow && this.plateNumberSecondRow.trim()
      const plateNumber = first && second ? `${first}-${second}` : null

      this.$store.dispatch('setVehicleProfile', {
        vehicle_type: this.vehicleType === VEHICLE.MOTORBIKE ? VEHICLE.MOTORBIKE : this.truckType.replace("_","-"),
        driving_license: this.drivingLicense,
        plate_number: plateNumber && plateNumber.toUpperCase()
      })
    },
    onChangeVehicleType (value) {
      if (value === VEHICLE.TRUCK) {
        this.truckType = TYPE_TRUCK.TRICYCLE
      }
      this.setVehicleProfile()
    },
    onChangeTruckType () {
      this.setVehicleProfile()
    },
    onChangeDrivingLicense (value) {
      this.drivingLicense = value
      this.setVehicleProfile();
    },
    onChangePlateNumber () {
      this.setVehicleProfile();
    }
  },
  created() {
    const formData = this.formData
    if (formData) {
      this.vehicleType = formData.vehicle_type === VEHICLE.TRUCK ? formData.vehicle_type : VEHICLE.MOTORBIKE
      if(formData.vehicle_type !== VEHICLE.MOTORBIKE && formData.vehicle_type !== VEHICLE.TRUCK){
        for(let key in TYPE_TRUCK){
          if(formData.vehicle_type && formData.vehicle_type.replace("-","_") === key){
            this.vehicleType = VEHICLE.TRUCK
          }
        }
      }
      
      this.truckType = formData.vehicle_type && formData.vehicle_type !== VEHICLE.MOTORBIKE && formData.vehicle_type.replace("-","_")
      this.drivingLicense = formData.driving_license
      if (formData.plate_number) {
        const plateNumberArray = formData.plate_number.split('-')
        this.plateNumberFirstRow = plateNumberArray[0] && plateNumberArray[0].trim()
        this.plateNumberSecondRow = plateNumberArray[1] && plateNumberArray[1].trim()
      }
    }
  }
};
</script>
<style lang="scss">
.vehicle-field {
  .selection {
    position: relative;

    .option-truck {
      margin-top: 25px;
    }
    .select {
      width: 100%;
      select {
        width: 100%;
        height: 46px;
        border: none;
        outline: none;
        background-color: #f2f2f2;

        &:focus {
          box-shadow: none;
        }
      }
    }
    .select:not(.is-multiple):not(.is-loading)::after {
      border-color: #7a8189;
      right: 1.125em;
      top: 1.5rem;
    }
  }
  .license-plates {
    padding: 5px 10px;
    align-items: center;

    p {
      font-size: 14px !important;
      color: #1a1a1a !important;
      margin-right: 20px;
      margin-bottom: 0;
    }

    input {
      height: 46px;
      background: #f2f2f2;
      border: none;
      outline: none;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
    }

    img {
      margin: 0 10px;
    }

    input.first {
      width: 70px;
    }
    input.second {
      width: 150px;
    }
  }
}
</style>
